// extracted by mini-css-extract-plugin
export default {"social-network":"SocialNetwork_social-network__8gl-V"};